
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import OsInputCheckbox from '@/components/core/input/OsInputCheckbox.vue';

@Component({
  components: { OsInputCheckbox }
})
export default class OsInputCheckboxGroup extends Vue {
  internalValue: { id: string; label: string; isSelected: boolean }[] = [];

  @Prop({ default: [] })
  items!: { id: string; label: string; isSelected: boolean }[];

  @Prop({ required: false, default: false })
  readonly!: string;

  @Watch('items')
  onItemsChanged() {
    this.internalValue = this.items;
  }

  mounted() {
    this.internalValue = this.items;
  }
}
